/* eslint-disable max-len */
import React from 'react';
import { createPortal } from 'react-dom';

const BUKKU_PORTAL_ID = "bukku-app-react-portal";

/**
 * - A mounting insertion point for those using ReactDOM.createPortal(),
 *   will mount under 'bkMainLayout' div
 *      - https://reactjs.org/docs/portals.html
 *      - eg: custom-made modals using div (like likebox) will mount here
 *      - using createPortal(<Lightbox/>, document.getElementById(BUKKU_PORTAL_ID))
 *
 * - Effect is similar to how antd-modal mounts to body.
 *
 * - This is to solve issues due to stacking context -->  z-index will not work
 *      - https://www.freecodecamp.org/news/4-reasons-your-z-index-isnt-working-and-how-to-fix-it-coder-coder-6bc05f103e6c/
 *
 * - Also refer this on why we don't mount directly to body:
 * - https://stackoverflow.com/questions/49504546/is-it-safe-to-use-reactdom-createportal-with-document-body
 */
export function BukkuReactPortal() {
    return (
        <div id={BUKKU_PORTAL_ID} style={{zIndex: 1001}} />
    );
}

/**
 * mount to a higher mounting stack context
 * @param {*} childrenDOM
 */
export const mountToPortal = childrenDOM => {
    const targetDOM = document.getElementById(BUKKU_PORTAL_ID);
    if (targetDOM)
        return createPortal(childrenDOM, targetDOM);
    return childrenDOM;
};
